import React from 'react';
import { Link } from 'react-router-dom';

const CareerPlan = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/services/career" className="text-indigo-600 hover:text-indigo-700 mb-4 inline-block">
          Back to Career Dashboard
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Career Plan</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600 mb-4">
            Create a personalized roadmap to achieve your career goals.
          </p>
          <p className="text-sm text-gray-500">Coming soon: Career plan builder</p>
        </div>
      </div>
    </div>
  );
};

export default CareerPlan;
